/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { EmptyState } from "../../components/EmptyState";
import { Divider } from "../../components/Divider";
import { DeliveryProvidersConfigurationsTable } from "./components/DeliveryProvidersConfigurationsTable";
import { useDeliveryProviderConfigurations } from "./service/delivery-provider-configrations-api";
import { MutateDeliveryProviderConfigurationSelector } from "./components/MutateDeliveryProviderConfigurationSelector";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const DeliveryProviderConfigurations = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const {
    data: deliveryProviderConfigurations,
    isLoading: deliveryProviderConfigurationsLoading,
  } = useDeliveryProviderConfigurations(organizationKeyName);

  if (
    deliveryProviderConfigurationsLoading ||
    !deliveryProviderConfigurations
  ) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Delivery provider configurations"
          subtitle="Manage all of your delivery provider configurations"
        >
          <MutateDeliveryProviderConfigurationSelector
            existingDeliveryProviders={deliveryProviderConfigurations.map(
              (deliveryProviderConfiguration) =>
                deliveryProviderConfiguration.provider
            )}
          />
        </PageHeader>
        {deliveryProviderConfigurations?.length === 0 ||
        !deliveryProviderConfigurations ? (
          <>
            <Divider />
            <CardBody additionalStyles={cardBodyAdditionalStyling}>
              <EmptyState
                title="No delivery provider configurations created yet"
                subtitle="Create your first delivery provider configuration by pressing on create delivery provider configuration in top right corner"
              />
            </CardBody>
          </>
        ) : (
          <DeliveryProvidersConfigurationsTable
            deliveryProviderConfigurations={deliveryProviderConfigurations}
          />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
